module.exports = __webpack_public_path__ + "img/new.db32c5f8.svg";